module.exports = __webpack_public_path__ + "static/media/s_sf_17.cbde47b0.png";